import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';
import Badge from '../framework/badges/badge';
import Btn from '../framework/buttons/btn';
import Trans from '../translation/trans';

const VISIT_TYPE_CONFIG = {
	archive: {
		alertVariant: 'danger',
		badgeVariant: 'danger',
		label: 't3',
	},
	assigned_booking: {
		alertVariant: 'info',
		badgeVariant: 'assigned_booking',
		info: 't5',
		label: 't4',
	},
	'drop-in': {
		alertVariant: 'primary',
		badgeVariant: 'primary',
		info: 't6',
		label: 't1',
	},
	manual_booking: {
		alertVariant: 'success',
		badgeVariant: 'manual_booking',
		info: 't7',
		label: 't2',
	},
};

const BookingBadge = ({
	size = 'sm',
	status,
	url_book,
	visit_type,
	withInformation,
}) => {
	const { t } = useTranslation('component_location_booking_badge');

	const visitTypes = Array.isArray(visit_type) ? visit_type : [visit_type];

	const typeConfigs = visitTypes
		.map((type) =>
			status === 'archive'
				? VISIT_TYPE_CONFIG.archive
				: VISIT_TYPE_CONFIG[type],
		)
		.filter(Boolean);

	if (!withInformation) {
		return (
			<>
				{typeConfigs.map((cfg, idx) => (
					<Badge
						key={idx}
						label={t(cfg.label)}
						size={size}
						variant={cfg.badgeVariant}
					/>
				))}
			</>
		);
	}

	return (
		<>
			{typeConfigs.map((type, index) => (
				<div
					className={`alert alert-${type.alertVariant} border-0 sm p-3 mt-3`}
					key={index}
				>
					<div className="row align-items-center">
						<div className="col-auto">
							<Badge
								className="mb-2 d-block"
								label={t(type.label)}
								size={size}
								variant={type.badgeVariant}
							/>
							<Trans i18nKey={type.info} t={t} /> <Trans i18nKey={'t9'} t={t} />
						</div>

						{url_book && (
							<div className="col-md-6 mt-2">
								<Btn
									aria-controls="offcanvasRight"
									color="dark"
									component="button"
									data-bs-target="#bookingOffCanvas"
									data-bs-toggle="offcanvas"
									fullWidth
									size="md"
									type="button"
								>
									{t('t8')}
								</Btn>
							</div>
						)}
					</div>
				</div>
			))}
		</>
	);
};

BookingBadge.propTypes = {
	size: PropTypes.string,
	status: PropTypes.string,
	url_book: PropTypes.string,
	visit_type: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
	]),
	withInformation: PropTypes.bool,
};

export default BookingBadge;
